

// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import {
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Avatar,
//   Box
// } from "@mui/material";
// import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import facebookVerifiedIcon from "assets/images/icons/socials/facebook-verified.png";
// import youtubeVerifiedIcon from "assets/images/icons/socials/youtube-verified.png";
// import MDBox from "components/MDBox";
// import ResponsiveCardMedia from "./ResponsiveCardMedia";
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import Tooltip from "@mui/material/Tooltip";
// import dayjs from "dayjs";
// import Footer from "./Footer";
// import Header from "./Header";

// function EntityCard({
//   entityObject,
//   platform,
//   entityType,
//   profileObject,
//   isSelected,
//   onSelect,
//   forcedHeight,
//   registerHeight
// }) {
//   const [imageSrc, setImageSrc] = useState(
//     entityObject.full_picture ||
//     entityObject.thumbnailUrl ||
//     entityObject.media_url ||
//     profileObject.profilePictureUrl
//   );

//   const handleClick = () => {
//     if (onSelect) onSelect(entityObject);
//   };

//   const renderPlatformIcon = () => {
//     if (platform === "Facebook") return <FacebookRoundedIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />;
//     if (platform === "Instagram") return <InstagramIcon fontSize="medium" sx={{ verticalAlign: "middle", mr: 0.5 }} />;
//     if (platform === "YouTube") return <YouTubeIcon fontSize="medium" sx={{ verticalAlign: "middle", mr: 0.5 }} />;
//     return null;
//   };

//   const getFormattedDate = () => {
//     const timestamp = entityObject.created_time || entityObject.publishedAt || entityObject.taken_at;
//     return timestamp ? dayjs(timestamp).format("MMM D, YYYY [at] h:mmA") : "Unknown date";
//   };

//   const getContentText = () => {
//     if (entityType === "post") {
//       return entityObject.message || entityObject.caption || "No message content available.";
//     }
//     if (entityType === "video") {
//       return entityObject.title || "No video title available.";
//     }
//     return "Unsupported entity";
//   };

//   const name = profileObject?.name || profileObject?.channelName || profileObject.label || "Unknown Name";
//   const verified = profileObject?.verifiedStatus || false;
//   const followerCount = profileObject?.count || entityObject?.subscribers || 0;
//   const countLabel = platform === "YouTube" ? "Subscribers" : "Followers";
//   const link = profileObject.link || "Unknown Link";

//   return (
//     <Card
//       onClick={handleClick}
//       sx={{
//         width: "100%",
//         maxWidth: 345,
//         borderRadius: 2,
//         overflow: "hidden",
//         cursor: "pointer",
//         boxShadow: isSelected ? 6 : 1,
//         border: isSelected ? "2px solid #00A1A1" : "1px solid #ddd",
//         position: "relative",
//         backgroundColor: isSelected ? "grey.500" : "grey.100",
//         transition: "all 0.3s ease-in-out",
//         '&:hover': { boxShadow: 6 },
//       }}
//     >
//       <Header
//         name={name}
//         platform={platform}
//         profilePictureUrl={profileObject.profilePictureUrl}
//         verified={verified}
//         link={link}
//         entityObject={entityObject}
//       />


//       <ResponsiveCardMedia
//         imageSrc={imageSrc}
//         fallbackSrc={profileObject.profilePictureUrl}
//         forcedHeight={forcedHeight}
//         registerHeight={registerHeight}
//       />

//       <CardContent
//         sx={{
//           py: 1,
//           px: 1.5,
//           height: 55,
//         }}
//       >
//         <Typography
//           variant="subtitle2"
//           sx={{
//             display: "-webkit-box",
//             WebkitLineClamp: 2,
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             fontSize: "0.9rem",
//           }}
//         >
//           {getContentText()}
//         </Typography>
//       </CardContent>
          
//       <Footer platform={platform} entityObject={entityObject} />

//       {isSelected && (
//         <MDBox
//           sx={{
//             position: "absolute",
//             top: 4,
//             right: 4,
//             backgroundColor: "#fff",
//             borderRadius: "50%",
//             width: 22,
//             height: 22,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <CheckCircleIcon sx={{ fontSize: 18, color: "#FFB347" }} />
//         </MDBox>
//       )}
//     </Card>
//   );
// }

// EntityCard.propTypes = {
//   entityObject: PropTypes.object.isRequired,
//   platform: PropTypes.string.isRequired,
//   entityType: PropTypes.string.isRequired,
//   profileObject: PropTypes.object.isRequired,
//   isSelected: PropTypes.bool,
//   onSelect: PropTypes.func,
//   forcedHeight: PropTypes.number,
//   registerHeight: PropTypes.func,
// };

// EntityCard.defaultProps = {
//   isSelected: false,
//   onSelect: null,
//   forcedHeight: null,
//   registerHeight: null,
// };

// export default EntityCard;


// #####################################

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Avatar,
  Box,
} from "@mui/material";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MDBox from "components/MDBox";
import ResponsiveCardMedia from "./ResponsiveCardMedia";
import dayjs from "dayjs";
import Footer from "./Footer";
import Header from "./Header";

function EntityCard({
  entityObject,
  platform,
  entityType,
  profileObject,
  isSelected,
  onSelect,
  forcedHeight,
  registerHeight,
  onViewAnalytics
}) {
  const [imageSrc, setImageSrc] = useState(
    entityObject.full_picture ||
      entityObject.thumbnailUrl ||
      // entityObject.media_url ||
      entityObject.thumbnail_url ||
      profileObject.profilePictureUrl
  );

  // 🔹 Fix: Update image whenever entityObject/profileObject changes
  useEffect(() => {
    setImageSrc(
      entityObject.full_picture ||
        entityObject.thumbnailUrl ||
        // entityObject.media_url ||
        entityObject.thumbnail_url ||
        profileObject.profilePictureUrl
    );
  }, [entityObject, profileObject]);

  // const handleClick = () => {
  //   if (onSelect) onSelect(entityObject);
  // };


  // Inside EntityCard.jsx
  const handleCardClick = (e) => {
    // If the user actually clicked an <a> (like "View Original Post"), let that behave normally
    if (e.target.closest('a')) return;

    // 1️⃣ Always preserve selection logic
    if (onSelect) {
      onSelect(entityObject);
    }

    // 2️⃣ Also trigger analytics modal if provided
    if (onViewAnalytics) {
      onViewAnalytics(entityObject);
    }
  };


  const renderPlatformIcon = () => {
    if (platform === "Facebook")
      return <FacebookRoundedIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />;
    if (platform === "Instagram")
      return <InstagramIcon fontSize="medium" sx={{ verticalAlign: "middle", mr: 0.5 }} />;
    if (platform === "YouTube")
      return <YouTubeIcon fontSize="medium" sx={{ verticalAlign: "middle", mr: 0.5 }} />;
    return null;
  };

  const getFormattedDate = () => {
    const timestamp = entityObject.created_time || entityObject.publishedAt || entityObject.taken_at;
    return timestamp ? dayjs(timestamp).format("MMM D, YYYY [at] h:mmA") : "Unknown date";
  };

  const getContentText = () => {
    if (entityType === "post") {
      return entityObject.message || entityObject.caption || "No message content available.";
    }
    if (entityType === "video") {
      return entityObject.title || "No video title available.";
    }
    return "Unsupported entity";
  };

  const name =
    profileObject?.name ||
    profileObject?.channelName ||
    profileObject.label ||
    "Unknown Name";
  const verified = profileObject?.verifiedStatus || false;
  const followerCount = profileObject?.count || entityObject?.subscribers || 0;
  const countLabel = platform === "YouTube" ? "Subscribers" : "Followers";
  const link = profileObject.link || "Unknown Link";

  return (
    <Card
      onClick={handleCardClick}
      sx={{
        width: "100%",
        maxWidth: 345,
        borderRadius: 2,
        overflow: "hidden",
        cursor: "pointer",
        boxShadow: isSelected ? 6 : 1,
        border: isSelected ? "2px solid #00A1A1" : "1px solid #ddd",
        position: "relative",
        backgroundColor: isSelected ? "grey.500" : "grey.200",
        transition: "all 0.3s ease-in-out",
        "&:hover": { boxShadow: 6 },
      }}
    >
      <Header
        name={name}
        platform={platform}
        profilePictureUrl={profileObject.profilePictureUrl}
        verified={verified}
        link={link}
        entityObject={entityObject}
        onViewAnalytics={onViewAnalytics} 
      />

      <ResponsiveCardMedia
        imageSrc={imageSrc}
        fallbackSrc={profileObject.profilePictureUrl}
        forcedHeight={forcedHeight}
        registerHeight={registerHeight}
      />

      <CardContent sx={{ py: 1, px: 1.5, height: 55 }}>
        <Typography
          variant="subtitle2"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.9rem",
          }}
        >
          {getContentText()}
        </Typography>
      </CardContent>

      <Footer platform={platform} entityObject={entityObject} />

      {isSelected && (
        <MDBox
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            backgroundColor: "#26282b",
            borderRadius: "50%",
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckCircleIcon color="accent" sx={{ fontSize: 18 }} />
        </MDBox>
      )}
    </Card>
  );
}

EntityCard.propTypes = {
  entityObject: PropTypes.object.isRequired,
  platform: PropTypes.string.isRequired,
  entityType: PropTypes.string.isRequired,
  profileObject: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  forcedHeight: PropTypes.number,
  registerHeight: PropTypes.func,
  onViewAnalytics: PropTypes.func,
};

EntityCard.defaultProps = {
  isSelected: false,
  onSelect: null,
  forcedHeight: null,
  registerHeight: null,
};

export default EntityCard;
